/* GoChess x Harry Potter landing page - the page's own script, unchanged except for the
   asset base, the storefront origin and this wrapper.
   Generated from v4/index.html by shopify-v4/build_js.py. Do not hand-edit. */
window.gcwV4Boot = function () {
/* ---------- data ---------- */
const U = (m,i) => ({m:m, i:i});
/* Authored in the order the Figma canvas lays them out; ORDER below is what ships.
   The three GoChess columns carry the spec values exactly as Figma has them. */
/* Wizard Alive carries no handle on purpose: its Shopify product reads $999 while the
   pre-order price Yahav confirmed is $699, so this row stays pinned and livePrices()
   skips it. Give it a handle again only once the store itself says $699. */
const SETS_SRC = [
  {h:'Modern, Tournament', p:'Modern Design',            sku:'GoChess Lite Modern',
   key:'go_modern', handle:'gochess-lite-modern',  price:['$249.99',''],           cta:'Buy Now',
   url:'https://particula-tech.com/products/gochess-lite-modern'},
  {h:'Modern, Travel',     p:'Modern, Travel size',      sku:'GoChess Mini',
   key:'go_mini', handle:'gochess-mini',    price:['$198.98',''],           cta:'Buy Now',
   url:'https://particula-tech.com/products/gochess-mini'},
  {h:'Self-Moving Pieces', p:'Pieces move on their own', sku:'Wizard Alive', hi:1,
   key:'alive',      price:['$699','+ Shipping'], cta:'Pre Order',
   url:'https://particula-tech.com/pages/gochess-wizard-alive-chess-self-moving-pieces'},
  {h:'Tournament Size',    p:'"Wow-factor" as a gift',   sku:'Wizard Lite',
   key:'lite', handle:'gochess-wizard-lite',       price:['$379.95',''],           cta:'Buy Now',
   url:'https://particula-tech.com/products/gochess-wizard-lite'},
  {h:'Standard Size',      p:'For "on-the-go"',          sku:'Wizard Mini',
   key:'mini', handle:'gochess-wizard-mini',       price:['$269.99',''],           cta:'Buy Now',
   url:'https://particula-tech.com/products/gochess-wizard-mini'},
  {h:'Wooden, Tournament', p:'Wooden Pieces',            sku:'GoChess Lite Classic',
   key:'go_classic', handle:'gochess-lite-classic', price:['$299.99',''],           cta:'Buy Now',
   url:'https://particula-tech.com/products/gochess-lite-classic'},
];
/* the three Wizard sets lead, the three GoChess sets follow */
const ORDER = [2, 3, 4, 5, 0, 1];
const SETS = ORDER.map(i => SETS_SRC[i]);
const MINI_SIZE  = U(['33.3 × 33.3 cm',''],['13.1 × 13.1 in','']);
const MINI_SQ    = U(['35 × 35 mm',''],['1.38 × 1.38 in','']);
const THIN       = U(['0.87 cm',''],['0.34 in','']);
const MINI_KINGH = U(['8.3 cm',''],['3.27 in','']);
const MINI_KINGW = U(['26 g',''],['0.92 oz','']);
const MINI_BOARDW= U(['1.2 kg','board + pieces'],['2.6 lb','board + pieces']);
const ABS_BOARD  = ['High-quality ABS frame','Heavy-duty matte-finish board surface'];
const CLEAN_VINYL= ['Weighted premium clean vinyl','High-density ABS'];
const TABLE = [
  {g:'Board & pieces', rows:[
    ['Board size', MINI_SIZE, MINI_SIZE,
      U(['50 × 50 cm',''],['19.7 × 19.7 in','']), U(['48.3 × 48.3 cm',''],['19 × 19 in','']), MINI_SIZE, MINI_SIZE],
    ['Board class',['Standard size',''],['Standard size',''],
      ['Full size','Self-moving'],['Full size','Tournament size'],['Standard size',''],['Standard size','']],
    ['Square size', MINI_SQ, MINI_SQ,
      U(['48 × 48 mm',''],['1.89 × 1.89 in','']), U(['48 × 48 mm',''],['1.89 × 1.89 in','']), MINI_SQ, MINI_SQ],
    ['Thickness', THIN, THIN, U(['4.8 cm',''],['1.89 in','']), THIN, THIN, THIN],
    ["King's height", MINI_KINGH, MINI_KINGH,
      U(['9.65 cm',''],['3.8 in','']), U(['9.6 cm',''],['3.78 in','']), MINI_KINGH, MINI_KINGH],
  ]},
  {g:'Materials & weight', rows:[
    ['Board material', ABS_BOARD, ABS_BOARD, ABS_BOARD, ABS_BOARD, ABS_BOARD, ABS_BOARD],
    ['Pieces material', CLEAN_VINYL, CLEAN_VINYL,
      ['Premium vinyl over high-density matte-textured ABS','Steel weights and magnets'],
      CLEAN_VINYL, CLEAN_VINYL, CLEAN_VINYL],
    ["King's weight", MINI_KINGW, MINI_KINGW,
      U(['35 g',''],['1.23 oz','']), U(['34 g',''],['1.2 oz','']), MINI_KINGW, MINI_KINGW],
    ['Board weight', MINI_BOARDW, MINI_BOARDW,
      U(['4.8 kg','board + robots'],['10.6 lb','board + robots']),
      U(['2.6 kg','board + pieces'],['5.7 lb','board + pieces']), MINI_BOARDW, MINI_BOARDW],
  ]},
];
const FAQ = [
  ["Do I need to be good at chess to enjoy this?","Not at all. The board's Coaching Lights show you every legal move for the piece you pick, flag the strongest option and warn you before a blunder. Beginners can lean on full assistance, and you can dial it down as you improve."],
  ["How long does the battery last?","A full charge covers several evenings of play. The board charges over USB-C and shows its level in the companion app."],
  ["Can kids use this safely?","Yes. The pieces are weighted vinyl over high-density ABS with no small loose parts, and the board runs on low-voltage USB-C power."],
  ["What if I already have a Chess.com account?","Just sign in from the companion app. Your board becomes the physical input for your existing account, ratings and games, and the included month of Diamond stacks onto it."],
  ["Will this ship in time for the Holiday?","Orders placed now are scheduled to arrive before December 24. Free shipping inside the US."],
];

/* ---------- table ---------- */
/* the six header cards share the table's grid, so they scroll with it */
(() => {
  const row = document.getElementById('setsRow');
  if (!row) return;
  /* Both plates are exported from Figma on the same 500-wide canvas, so the boards
     keep their true size against each other and the trios line up on one baseline. */
  const plate = (kind, key) => (window.GCW_PLATE || 'assets/') + `cmp_${kind}_${key}.webp`;
  row.innerHTML = '<div class="pad" aria-hidden="true">&#8203;</div>' + SETS.map(s => `
    <div class="set${s.hi ? ' set--hi' : ''}">
      <h3>${s.sku}</h3><p>${s.h}</p><p>${s.p}</p>
      <img class="setimg" src="${plate('brd', s.key)}" alt="${s.sku} board" width="900" height="578" loading="lazy">
      <img class="setpcs" src="${plate('pcs', s.key)}" alt="" aria-hidden="true" width="900" height="319" loading="lazy">
    </div>`).join('');
})();

const root = document.getElementById('tblRoot');
let unit = 'i';
try { const st = localStorage.getItem('gc-units'); if (st === 'm' || st === 'i') unit = st; } catch(e) {}
const cell = (v,hi) => {
  const d = (v && v.m) ? v[unit] : v;
  return `<div class="tcell${hi?' hi':''}">${d[0]?`<b>${d[0]}</b>`:''}${d[1]?`<i>${d[1]}</i>`:''}</div>`;
};
function renderTable(){
  let html='';
  TABLE.forEach((grp,gi)=>{
    html += `<button class="tgrp open" type="button" aria-expanded="true" aria-controls="tb${gi}" data-g="${gi}"><span class="tgrp__ic" aria-hidden="true"></span><b class="tgrp__t">${grp.g}</b></button><div class="tbody" id="tb${gi}" data-b="${gi}">`;
    grp.rows.forEach(r=>{
      html += `<div class="trow"><div class="tcell lab">${r[0]}</div>` +
        SETS.map((s,k)=>cell(r[ORDER[k]+1], s.hi)).join('') + `</div>`;
    });
    html += `</div>`;
  });
  html += `<div class="trow tbl__cta"><div class="tcell lab"></div>` + SETS.map(s=>
    `<div class="tcell${s.hi?' hi':''}"><div class="price"${s.handle?` data-h="${s.handle}"`:''}>${s.price[0]}${s.price[1]?` <small>${s.price[1]}</small>`:''}</div><a class="buy" href="${s.url}">${s.cta}</a></div>`).join('') + `</div>`;
  root.innerHTML = html;
  bindGroups();
}
const units = document.getElementById('units');
if (units) {
  units.querySelectorAll('button').forEach(b=>b.addEventListener('click',()=>{
    unit = b.dataset.u;
    units.querySelectorAll('button').forEach(x=>x.setAttribute('aria-pressed', String(x.dataset.u === unit)));
    try { localStorage.setItem('gc-units', unit); } catch(e) {}
    renderTable();
  }));
  units.querySelectorAll('button').forEach(x=>x.setAttribute('aria-pressed', String(x.dataset.u === unit)));
}
renderTable();
function bindGroups(){
root.querySelectorAll('.tgrp').forEach(g=>{
  const b = root.querySelector(`[data-b="${g.dataset.g}"]`);
  const settle = () => { if (g.classList.contains('open')) b.classList.add('settled'); };
  b.addEventListener('transitionend', e => { if (e.propertyName === 'max-height') settle(); });
  b.style.maxHeight = b.scrollHeight + 'px';
  settle();
  g.addEventListener('click',()=>{
    const willOpen = !g.classList.contains('open');
    b.classList.remove('settled');
    b.style.maxHeight = willOpen ? '0px' : b.scrollHeight + 'px';   // a real start for the transition
    void b.offsetHeight;
    g.classList.toggle('open', willOpen);
    g.setAttribute('aria-expanded', String(willOpen));
    b.style.maxHeight = willOpen ? b.scrollHeight + 'px' : '0px';
    b.toggleAttribute('data-closed', !willOpen);
  });
});
const remeasure = () => root.querySelectorAll('.tgrp.open').forEach(g=>{
  const b = root.querySelector(`[data-b="${g.dataset.g}"]`);
  if (b.classList.contains('settled')) return;        // already at its natural height
  b.style.maxHeight = 'none'; b.style.maxHeight = b.scrollHeight + 'px';
});
addEventListener('resize', remeasure, {passive:true});
if (document.fonts && document.fonts.ready) document.fonts.ready.then(remeasure);
}

/* ---------- faq ---------- */
document.getElementById('faq').innerHTML = FAQ.map(([q,a],i)=>
  `<div class="qa${i===0?' open':''}"><button class="qa__q" type="button">${q}<span></span></button><div class="qa__a"><p>${a}</p></div></div>`).join('');
document.querySelectorAll('.qa').forEach(qa=>{
  const a = qa.querySelector('.qa__a');
  const set = () => a.style.maxHeight = qa.classList.contains('open') ? a.scrollHeight+'px' : '0px';
  qa.querySelector('.qa__q').addEventListener('click',()=>{ qa.classList.toggle('open'); set(); });
  set();
});
addEventListener('resize',()=>document.querySelectorAll('.qa.open .qa__a').forEach(a=>a.style.maxHeight=a.scrollHeight+'px'));

/* ---------- stars ---------- */
const STAR = '<svg viewBox="0 0 20 20"><defs><linearGradient id="sg" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#f9e78d"/><stop offset="1" stop-color="#ca9e48"/></linearGradient></defs><path fill="url(#sg)" d="M10 1.6l2.5 5.2 5.7.8-4.1 4 1 5.7-5.1-2.7-5.1 2.7 1-5.7-4.1-4 5.7-.8z"/></svg>';
document.querySelectorAll('.stars').forEach(s=>s.innerHTML = STAR.repeat(5));

/* ---------- live prices ---------- */
/* The sets are priced in Shopify, not here. The printed price renders first so the table is
   never blank and never shifts, then the store's own number replaces it. Shopify serves
   /products/<handle>.js with Access-Control-Allow-Origin:*, so this reads fine from any
   origin. It fires on approach to #buy, so a visitor who never scrolls there pays nothing. */
const STORE = (typeof window.GCW_STORE === 'string')
  ? window.GCW_STORE : 'https://particula-tech.com';
const money = cents => {
  const n = cents / 100;
  return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
};
let pricesFetched = false;
function livePrices(){
  if (pricesFetched) return;
  pricesFetched = true;
  SETS.filter(s => s.handle).forEach(s => {
    fetch(STORE + '/products/' + s.handle + '.js')
      .then(r => r.ok ? r.json() : Promise.reject(r.status))
      .then(p => {
        const el = document.querySelector('.price[data-h="' + s.handle + '"]');
        if (!el || typeof p.price !== 'number') return;
        el.innerHTML = money(p.price) + (s.price[1] ? ' <small>' + s.price[1] + '</small>' : '');
      })
      .catch(() => {});   /* the printed price stands */
  });
}
const buySec = document.getElementById('buy');
if (buySec && 'IntersectionObserver' in window) {
  const pio = new IntersectionObserver(es => {
    if (es.some(e => e.isIntersecting)) { pio.disconnect(); livePrices(); }
  }, {rootMargin: '600px 0px'});
  pio.observe(buySec);
} else livePrices();

/* ---------- unboxing carousel ---------- */
(() => {
  const rail = document.getElementById('ubxRail'), dotsBox = document.getElementById('ubxDots');
  if (!rail || !dotsBox) return;
  const clips = [...rail.children];
  dotsBox.innerHTML = clips.map((_, i) => `<button type="button" aria-label="Show clip ${i + 1}"></button>`).join('');
  const dots = [...dotsBox.children];
  const mark = () => {
    const i = Math.round(rail.scrollLeft / rail.clientWidth);
    dots.forEach((d, n) => d.setAttribute('aria-current', n === i ? 'true' : 'false'));
  };
  dots.forEach((d, i) => d.addEventListener('click', () =>
    rail.scrollTo({ left: i * rail.clientWidth, behavior: 'smooth' })));
  rail.addEventListener('scroll', () => { clearTimeout(rail._t); rail._t = setTimeout(mark, 90); }, {passive:true});
  mark();
})();

/* ---------- reviews rail dots ---------- */
(() => {
  const rail = document.querySelector('.quotes'), box = document.getElementById('qDots');
  if (!rail || !box) return;
  const cards = [...rail.querySelectorAll('.quote')];
  box.innerHTML = cards.map((_, i) => `<button type="button" aria-label="Show review ${i + 1}"></button>`).join('');
  const dots = [...box.children];
  const arrows = [...document.querySelectorAll('.qarrow')];
  /* the cards snap on their centres and the rail carries its own side padding, so a
     card's scroll position is measured against the rail rather than derived from an
     index; offsetLeft is no use here because the rail is not the offset parent */
  const mid = () => rail.getBoundingClientRect().left + rail.clientWidth / 2;
  const off = el => { const r = el.getBoundingClientRect(); return r.left + r.width / 2 - mid(); };
  const at = () => { let best = 0, d = Infinity;
    cards.forEach((el, i) => { const x = Math.abs(off(el)); if (x < d) { d = x; best = i; } });
    return best; };
  /* rapid taps queue off the target rather than off a scroll still in flight */
  let want = 0;
  const go = i => { want = Math.min(cards.length - 1, Math.max(0, i));
    rail.scrollTo({ left: rail.scrollLeft + off(cards[want]), behavior: 'smooth' }); };
  const sync = () => { const i = at();
    dots.forEach((d, n) => d.setAttribute('aria-current', n === i ? 'true' : 'false'));
    arrows.forEach(a => a.toggleAttribute('disabled',
      a.dataset.q === 'prev' ? i <= 0 : i >= cards.length - 1)); };
  dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
  arrows.forEach(a => a.addEventListener('click', () => go(want + (a.dataset.q === 'next' ? 1 : -1))));
  rail.addEventListener('scroll', () => { clearTimeout(rail._t);
    rail._t = setTimeout(() => { want = at(); sync(); }, 110); }, {passive:true});
  sync();
})();

/* ---------- host chrome ----------
   On its own the hero starts at the top of the document. Inside a storefront a theme
   header and its announcement bar sit above it, and the first screen has to give that
   height back or the button falls below the fold. Measured rather than assumed, and
   set on the hero itself so the section's own :root block cannot shadow it. */
(() => {
  const hero = document.querySelector('.hero');
  if (!hero) return;
  const fit = () => {
    hero.style.removeProperty('--chrome');
    const top = Math.round(hero.getBoundingClientRect().top + window.scrollY);
    hero.style.setProperty('--chrome', Math.max(0, Math.min(top, 400)) + 'px');
  };
  /* the phone hero's wash is the clip's own poster, read off the element so it is already
     absolute and already cached, wherever the page is being served from */
  const mob = hero.querySelector('.hero__mobvid video');
  if (mob && mob.poster) hero.style.setProperty('--hero-wash', 'url("' + mob.poster + '")');
  fit();
  addEventListener('resize', fit, {passive:true});
  addEventListener('load', fit);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
})();

/* ---------- lazy video ---------- */
const vio = new IntersectionObserver(es=>es.forEach(e=>{
  const v = e.target;
  if (e.isIntersecting){
    /* the browser fetches a poster eagerly even at preload=none, so the poster is held
       back in data-poster and attached here, one rootMargin ahead of the clip itself */
    if (v.dataset.poster){ v.poster = v.dataset.poster; delete v.dataset.poster; }
    if(v.preload==='none'){v.preload='auto';v.load();}
    v.play().catch(()=>{});
  }
  else v.pause();
}),{rootMargin:'250px 0px',threshold:.01});
document.querySelectorAll('video[data-lazy]').forEach(v=>vio.observe(v));

/* ---------- infinite rails ---------- */
/* Three copies of the strip live in the DOM. Whenever the centred card drifts out of
   the middle copy we jump to its twin there: the twin is identical, so nothing shows. */
function makeInfinite(track, opts){
  opts = opts || {};
  const N = track.children.length;
  if (!N) return null;

  /* three copies of the strip; when the centred card drifts out of the middle copy we
     hop to its twin there, and since the twin is identical nothing shows on screen */
  const before = document.createDocumentFragment(), after = document.createDocumentFragment();
  [...track.children].forEach(node => [before, after].forEach(frag => {
    const c = node.cloneNode(true);
    c.dataset.clone = '1';
    c.setAttribute('aria-hidden', 'true');
    c.querySelectorAll('video').forEach(v => { v.preload = 'none'; vio.observe(v); });
    frag.appendChild(c);
  }));
  track.insertBefore(before, track.firstChild);
  track.appendChild(after);

  /* offsetLeft is relative to the nearest positioned ancestor (.rail), not to the
     scrolling track, so every measurement goes through getBoundingClientRect */
  const rect = el => el.getBoundingClientRect();
  const posOf = el => rect(el).left - rect(track).left + track.scrollLeft;
  const centreOf = el => posOf(el) - (track.clientWidth - rect(el).width) / 2;
  const clamp = x => Math.max(0, Math.min(x, track.scrollWidth - track.clientWidth));
  const centred = () => {
    const mid = rect(track).left + track.clientWidth / 2;
    let best = 0, bd = Infinity;
    [...track.children].forEach((c, i) => {
      const r = rect(c), d = Math.abs(r.left + r.width / 2 - mid);
      if (d < bd) { bd = d; best = i; }
    });
    return best;
  };

  let cur = ((opts.start || 0) % N + N) % N;
  const paint = i => {
    [...track.children].forEach((c, k) => c.classList.toggle('is-mid', k === i));
    if (opts.onMove) opts.onMove(((i % N) + N) % N);
  };

  function settle(){
    const i = centred();
    cur = ((i % N) + N) % N;
    if (i < N || i >= 2 * N) {            // drifted into a clone copy: hop to the twin
      const twin = track.children[N + cur];
      track.scrollLeft = clamp(centreOf(twin));
      paint(N + cur);
    }
    if (opts.onMove) opts.onMove(cur);
  }

  /* Chrome swallows scrollTo({behavior:'smooth'}) on a mandatory scroll-snap
     container, so the glide is driven here instead, with snapping off meanwhile */
  let raf = 0, busy = false;
  const soft = matchMedia('(prefers-reduced-motion: reduce)');
  function glide(x, instant){
    cancelAnimationFrame(raf);
    x = clamp(x);
    if (instant || soft.matches) { busy = false; track.style.scrollSnapType = ''; track.scrollLeft = x; return; }
    const from = track.scrollLeft, delta = x - from, t0 = performance.now(), dur = 420;
    if (Math.abs(delta) < 1) return;
    busy = true;
    track.style.scrollSnapType = 'none';
    const ease = p => 1 - Math.pow(1 - p, 3);
    const tick = now => {
      const p = Math.min(1, (now - t0) / dur);
      track.scrollLeft = from + delta * ease(p);
      if (p < 1) { raf = requestAnimationFrame(tick); return; }
      track.style.scrollSnapType = '';
      busy = false;
      settle();
    };
    raf = requestAnimationFrame(tick);
  }

  const goToChild = (domIndex, instant) => {
    const el = track.children[domIndex];
    if (!el) return;                      // the clones were torn down (grid layout took over)
    cur = ((domIndex % N) + N) % N;
    glide(centreOf(el), instant);
    paint(domIndex);
  };
  const goTo = (logical, instant) => {
    const l = ((logical % N) + N) % N;
    if (instant) return goToChild(N + l, true);
    const c = centred(), base = Math.floor(c / N) * N;     // stay in whichever copy we are in
    const near = [base - N + l, base + l, base + N + l]
      .filter(i => i >= 0 && i < 3 * N)
      .reduce((a, b) => Math.abs(b - c) < Math.abs(a - c) ? b : a);
    goToChild(near, false);
  };

  let t;
  track.addEventListener('scroll', () => {
    if (busy) return;                     // our own animation is driving
    paint(centred());
    clearTimeout(t); t = setTimeout(settle, 130);
  }, { passive: true });
  const onResize = () => goTo(cur, true);
  addEventListener('resize', onResize);
  requestAnimationFrame(() => goTo(cur, true));

  return {
    next: () => goToChild(centred() + 1),
    prev: () => goToChild(centred() - 1),
    goTo,
    teardown(){
      removeEventListener('resize', onResize); clearTimeout(t); cancelAnimationFrame(raf);
      track.style.scrollSnapType = '';
      track.querySelectorAll('[data-clone]').forEach(n => n.remove());
      track.querySelectorAll('.is-mid').forEach(n => n.classList.remove('is-mid'));
    }
  };
}

const rail = document.getElementById('ugcRail');
/* one dot per clip, built here so adding a clip to the rail is the only edit needed */
const dotsBox = document.getElementById('ugcDots');
if (dotsBox && rail && !dotsBox.children.length) {
  dotsBox.innerHTML = [...rail.children]
    .map((_, i) => `<button type="button" aria-label="Go to review ${i + 1}"></button>`).join('');
}
const dots = [...document.querySelectorAll('#ugcDots button')];
const ugc = makeInfinite(rail, {
  start: 0,                                   // open on the first clip, which now has sound
  onMove: i => dots.forEach((d, k) => d.classList.toggle('on', k === i))
});
document.querySelectorAll('[data-rail]').forEach(b => b.addEventListener('click', () =>
  b.dataset.rail === 'next' ? ugc.next() : ugc.prev()));
dots.forEach((d, i) => d.addEventListener('click', () => ugc.goTo(i)));

/* ---------- rail sound ----------
   Nothing about the default changes: every clip still autoplays muted and loops.
   The speaker is an opt-in on one clip at a time, and anything that moves the rail
   or takes it off screen puts the sound back to silent. */
(() => {
  if (!rail) return;
  const vids = () => [...rail.querySelectorAll('video')];
  let live = null;
  const silence = () => { vids().forEach(v => { v.muted = true; });
    rail.querySelectorAll('.snd').forEach(b => b.setAttribute('aria-pressed', 'false'));
    live = null; };
  rail.addEventListener('click', e => {
    const btn = e.target.closest('.snd');
    if (!btn) return;
    const v = btn.parentElement.querySelector('video');
    const on = live === v;
    silence();
    if (!on) { live = v; v.muted = false; v.volume = 1;
      btn.setAttribute('aria-pressed', 'true');
      btn.setAttribute('aria-label', 'Mute');
      v.play().catch(() => {}); }
  });
  /* a swipe or an arrow moves to another clip, so the sound stops with it */
  rail.addEventListener('scroll', () => { if (live) silence(); }, {passive: true});
  /* and it never follows the reader down the page */
  new IntersectionObserver(es => es.forEach(e => { if (!e.isIntersecting && live) silence(); }),
    {threshold: 0.25}).observe(rail);
  document.addEventListener('visibilitychange', () => { if (document.hidden) silence(); });
})();


/* ---------- scroll effects ---------- */
(() => {
  const soft = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (soft) return;

  const io = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return;
    const el = e.target;
    el.classList.add('in');
    io.unobserve(el);
    if (el.style.transitionDelay) setTimeout(() => { el.style.transitionDelay = ''; }, 1400);
  }), {rootMargin: '0px 0px -10% 0px', threshold: 0.06});

  // text and cards rise in, staggered per parent
  const SEL = 'h2,h3,.eyebrow,.lead,.att,.badge,.logos,.wb,.units,.orn,' +
              '.legend__i,.bitem,.quote,.set,.qa,.mode,.level__txt,.ugc';
  const groups = new Map();
  document.querySelectorAll('section, .move').forEach(sec => {
    sec.querySelectorAll(SEL).forEach(el => {
      if (el.closest('.hero') || el.closest('.qa__a')) return;
      const k = el.parentElement;
      if (!groups.has(k)) groups.set(k, []);
      groups.get(k).push(el);
    });
  });
  groups.forEach(list => list.forEach((el, i) => {
    el.classList.add('rv');
    if (list.length > 1) el.style.transitionDelay = Math.min(i * 55, 330) + 'ms';
    io.observe(el);
  }));

  // the big media wipes open from the bottom.
  // Chrome reports intersectionRatio 0 while an element's own clip-path has collapsed it,
  // so these need their own observer at threshold 0 or they would never fire.
  const ioc = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return;
    e.target.classList.add('in');
    ioc.unobserve(e.target);
  }), {rootMargin: '0px 0px -8% 0px', threshold: 0});
  document.querySelectorAll('.moves__vis,.unbox__vid,.pieces,.move__vis,.mode__ph')
    .forEach(el => { el.classList.add('rvc'); ioc.observe(el); });

  // touch has no hover, so the board effect plays whenever a card is on screen.
  // The capability is re-checked on every callback, not once at load, so a hybrid
  // device or a viewport change never leaves the cards frozen.
  const fineHover = () => matchMedia('(hover: hover) and (pointer: fine)').matches;
  const iob = new IntersectionObserver(es => {
    if (fineHover()) return;
    es.forEach(e => e.target.classList.toggle('on', e.isIntersecting));
  }, {rootMargin: '-10% 0px -10% 0px', threshold: 0});
  document.querySelectorAll('.bwrap').forEach(el => iob.observe(el));
  document.documentElement.dataset.touch = fineHover() ? '0' : '1';

  // swipe affordance for the comparison table
  const tw = document.querySelector('.tscrollw'), tsc = tw && tw.querySelector('.tscroll');
  if (tsc) {
    const prev = tw.querySelector('.tarrow--prev'), next = tw.querySelector('.tarrow--next');
    const sync = () => {
      const max = tsc.scrollWidth - tsc.clientWidth;
      const end = tsc.scrollLeft >= max - 4;
      tw.classList.toggle('at-end', end);
      if (tsc.scrollLeft > 12) tw.classList.add('touched');
      const overflows = max > 8;
      [prev, next].forEach(b => { if (b) b.hidden = !overflows; });
      if (prev) prev.disabled = tsc.scrollLeft <= 4;
      if (next) next.disabled = end;
    };
    /* one product column per click; scrollTo smooth is fine here, this container does not snap */
    const stepBy = dir => {
      const col = tw.querySelector('.set');
      const w = col ? col.getBoundingClientRect().width : 220;
      tsc.scrollBy({left: dir * w, behavior: 'smooth'});
    };
    if (prev) prev.addEventListener('click', () => stepBy(-1));
    if (next) next.addEventListener('click', () => stepBy(1));
    tsc.addEventListener('scroll', sync, {passive: true});
    addEventListener('resize', sync, {passive: true});
    sync();
  }

  // backgrounds drift against the scroll
  const par = [...document.querySelectorAll('[data-par]')];
  if (par.length) {
    let ticking = false;
    const draw = () => {
      const vh = innerHeight;
      par.forEach(el => {
        const p = el.parentElement.getBoundingClientRect();
        const off = (p.top + p.height / 2 - vh / 2) * -0.055;
        el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0) scale(1.14)';
      });
      ticking = false;
    };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(draw); } }, {passive: true});
    addEventListener('resize', draw, {passive: true});
    draw();
  }
})();

/* ---------- sticky CTA ---------- */
(() => {
  const bar = document.getElementById('stickyCta');
  const hero = document.querySelector('.hero');
  const buy = document.getElementById('buy');
  const close = document.querySelector('.move');
  if (!bar || !hero) return;
  let past = false, atOffer = false;
  const upd = () => bar.classList.toggle('on', past && !atOffer);
  new IntersectionObserver(es => { past = !es[0].isIntersecting; upd(); }, {threshold: 0}).observe(hero);
  // the offer table and the closing block carry their own CTA, so the bar stands down there
  const seen = new Map();          // a callback only carries the entries that changed
  const off = new IntersectionObserver(es => {
    es.forEach(e => seen.set(e.target, e.isIntersecting));
    atOffer = [...seen.values()].some(Boolean);
    upd();
  }, {threshold: 0});
  [buy, close].filter(Boolean).forEach(el => off.observe(el));
  
})();
};
if (!window.__gcwV4) { window.__gcwV4 = 1; window.gcwV4Boot(); }
/* the theme editor swaps the section's markup out from under us, so rebuild on it */
document.addEventListener('shopify:section:load', function (e) {
  if (e.target && e.target.querySelector && e.target.querySelector('[data-gcw-root]')) {
    try { window.gcwV4Boot(); } catch (err) {}
  }
});
